module.exports = __webpack_public_path__ + "img/square-kanban-solid.1dd3ef68.svg";